import React from 'react'
import SettingShippingCarrierContext from '../context/SettingShippingCarrierContext'
import PropTypes from 'prop-types'

function SettingShippingCarrierProvider(props) {
    const {loadShippingCarriers, loadShippingCarriersEdit, setState, filters} = props

    return (
        <SettingShippingCarrierContext.Provider
            value={{
                reLoadShippingCarriers: loadShippingCarriers,
                reLoadShippingCarriersEdit: loadShippingCarriersEdit,
                filters,
                setState: setState
            }}
        >
            {props.children}
        </SettingShippingCarrierContext.Provider>
    )
}

SettingShippingCarrierProvider.propTypes = {
    loadShippingCarriers: PropTypes.func.isRequired
}

export default SettingShippingCarrierProvider
